let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gpJf2")).then(() => parcelRequire('8dyHT'));